<template>
    <div class="container">
        <b-modal
            :model-value="showDialogInfo"
            :no-close-on-backdrop="true"
            hide-footer
            centered
            size="lg"
            :title="labels.listSubsidiary"
            header-class="reset-modal-header"
            title-class="reset-modal-title"
            body-class="reset-modal-body"
            class="reset-password-dialog list-subsidiary-dialog"
            @hide="clicked">
            <div class="uniform-modal-body">
                <div class="password-policy-box mb-4">
                    <div class="password-policy-title">{{ companyName?.nombre }}</div>
                    <div class="password-policy-subtitle">{{ labels.infoText }}</div>
                </div>

                <b-row class="d-flex align-items-center uniform-form-row mb-3">
                    <b-col cols="12" md="7" class="text-left">
                        <label class="form-label">{{ labels.vigencia }}</label>
                        <b-form-select
                            v-model="selVigencia"
                            class="form-input"
                            @change="onVigenciaChange"
                        >
                            <option value="" disabled>-- {{ labels.selectVigencia }} --</option>
                            <option v-for="v in listVigencias" :key="v" :value="v">
                                {{ v }}
                            </option>
                            <option value="__NEW__">+ {{ labels.newVigencia }}</option>
                        </b-form-select>
                    </b-col>
                </b-row>

                <b-row v-if="selVigencia === '__NEW__'" class="d-flex align-items-end uniform-form-row mb-3">
                    <b-col cols="12" md="8" class="text-left">
                        <label class="form-label">{{ labels.newVigencia }}</label>
                        <b-form-input
                            v-model="newVigencia"
                            type="text"
                            class="form-input"
                            placeholder="YYYYMM (ej: 202501)"
                            maxlength="6"
                        />
                        <small class="text-muted d-block mt-1">
                            {{ labels.propagationInfo }}
                        </small>
                    </b-col>
                    <b-col cols="12" md="4" class="text-left">
                        <b-button
                            class="reset-btn-primary"
                            style="width: 100%; margin-top: 24px;"
                            @click="createVigencia"
                        >
                            {{ labels.createVigencia }}
                        </b-button>
                    </b-col>
                </b-row>

                <div v-if="selVigencia && selVigencia !== '__NEW__'">
                    <div v-if="subsidiaryList?.length > 0">
                        <b-row class="d-flex align-items-center uniform-form-row" style="border-bottom: 1px solid #e0e0e0; padding-bottom: 8px; margin-bottom: 8px;">
                            <b-col cols="6" class="text-left">
                                <strong>{{ labels.subsidiary }}</strong>
                            </b-col>
                            <b-col cols="3" class="text-right">
                                <strong>{{ labels.stake }}</strong>
                            </b-col>
                            <b-col cols="3" class="text-center">
                                <strong>{{ labels.actions }}</strong>
                            </b-col>
                        </b-row>
                        <b-row
                            v-for="subsidiary in subsidiaryList"
                            :key="`${subsidiary.id_compania}-${subsidiary.id_subsidiaria}-${subsidiary.vigencia}`"
                            class="d-flex align-items-center uniform-form-row"
                        >
                            <b-col cols="6" class="text-left">
                                <span>{{ getNameSubsidiary(subsidiary?.id_subsidiaria) }}</span>
                            </b-col>
                            <b-col cols="3" class="text-right">
                                <template v-if="editingId === subsidiary.id">
                                    <b-form-input
                                        v-model="editingParticipacion"
                                        type="number"
                                        class="form-input"
                                        style="max-width: 90px; display: inline-block;"
                                        min="0"
                                        max="100"
                                        size="sm"
                                    />
                                    <span class="ml-1">%</span>
                                </template>
                                <template v-else>
                                    <span>{{ subsidiary.participacion }} %</span>
                                </template>
                            </b-col>
                            <b-col cols="3" class="text-center">
                                <template v-if="editingId === subsidiary.id">
                                    <b-button
                                        size="sm"
                                        class="reset-btn-primary mr-1"
                                        style="width: 32px; height: 32px; padding: 0; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center;"
                                        @click="saveEdit(subsidiary)"
                                    >
                                        <font-awesome-icon :icon="['fas', 'check']" style="font-size: 12px;" />
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        class="reset-btn-secondary"
                                        style="width: 32px; height: 32px; padding: 0; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center;"
                                        @click="cancelEdit"
                                    >
                                        <font-awesome-icon :icon="['fas', 'times']" style="font-size: 12px;" />
                                    </b-button>
                                </template>
                                <template v-else>
                                    <b-button
                                        size="sm"
                                        class="reset-btn-primary mr-1"
                                        style="width: 32px; height: 32px; padding: 0; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center;"
                                        @click="startEdit(subsidiary)"
                                    >
                                        <font-awesome-icon :icon="['fas', 'edit']" style="font-size: 12px;" />
                                    </b-button>
                                    <b-button
                                        size="sm"
                                        class="reset-btn-danger"
                                        style="width: 32px; height: 32px; padding: 0; border-radius: 4px; display: inline-flex; align-items: center; justify-content: center;"
                                        @click="confirmDeleteSubsidiary(subsidiary)"
                                    >
                                        <font-awesome-icon :icon="['fas', 'trash']" style="font-size: 12px;" />
                                    </b-button>
                                </template>
                            </b-col>
                        </b-row>
                    </div>
                    <div v-else class="text-center text-muted py-3">
                        <p>{{ labels.noSubsidiaries }}</p>
                    </div>

                    <div class="text-center mt-3" v-if="!showRow">
                        <b-button
                            class="reset-btn-primary"
                            @click="newSubsidiary"
                        >
                            <font-awesome-icon :icon="['fas', 'plus']" class="mr-1" />
                            {{ labels.addSubsidiary }}
                        </b-button>
                    </div>

                    <div v-if="showRow" class="mt-4">
                        <h5 class="mb-3" style="color: #016690; font-weight: 600;">{{ labels.addSubsidiary }}</h5>

                        <b-row class="d-flex align-items-end uniform-form-row">
                            <b-col cols="12" md="5" class="text-left">
                                <label class="form-label">{{ labels.subsidiary }}</label>
                                <b-form-select
                                    v-model="selSubsidiary"
                                    class="form-input"
                                >
                                    <option value="" disabled>-- {{ labels.selectSubsidiary }} --</option>
                                    <option v-for="comp in listCompany" :key="comp?.id" :value="comp?.id">
                                        {{ comp?.nombre }}
                                    </option>
                                </b-form-select>
                            </b-col>
                            <b-col cols="12" md="4" class="text-left">
                                <label class="form-label">{{ labels.stake }}</label>
                                <b-form-input
                                    v-model="cantPartici"
                                    type="number"
                                    class="form-input"
                                    placeholder="%"
                                    min="0"
                                    max="100"
                                />
                            </b-col>
                            <b-col cols="12" md="3" class="text-left">
                                <b-button
                                    class="reset-btn-primary"
                                    @click="createSubsidiary"
                                    style="width: 100%; margin-top: 24px;"
                                >
                                    {{ labels.create }}
                                </b-button>
                            </b-col>
                        </b-row>
                    </div>
                </div>
                <div v-else-if="selVigencia !== '__NEW__'" class="text-center text-muted py-3">
                    <p>{{ labels.selectVigenciaMsg }}</p>
                </div>

                <div class="reset-dialog-actions d-flex justify-content-end mt-4 uniform-actions-wrap">
                    <b-button class="reset-btn-secondary" @click="clicked">{{ labels.close }}</b-button>
                </div>
            </div>
        </b-modal>

        <InacticaItem
            :InactivaItem="showDeleteModal"
            @confirmDelete="confirmDelete"
            @cierraModal="closeDeleteModal"
        />
    </div>
</template>

<script>
import Company from "../../services/Company"
import Subsidiary from "../../services/Subsidiary"
import InacticaItem from "../utils/InacticaItem.vue"

export default {
    name: "ListSubsidiary",
    components: {
        InacticaItem
    },
    props: ['showDialogInfo', 'companyName'],
    data: () => ({
        listCompany: [],
        listCompanySub: [],
        listVigencias: [],
        selVigencia: "",
        newVigencia: "",
        showRow: false,
        selSubsidiary: "",
        cantPartici: "",
        error: false,
        showDeleteModal: false,
        subsidiaryToDelete: null,
        subsidiaryList: [],
        editingId: null,
        editingParticipacion: null
    }),
    computed: {
        labels() {
            if (this.$store.state._language == "es-ES") {
                return {
                    listSubsidiary: "Lista de Subsidiarias",
                    subsidiary: "Subsidiaria",
                    stake: "Participación",
                    matrix: "Matriz:",
                    create: "Crear",
                    save: "Guardar",
                    close: "Cerrar",
                    addSubsidiary: "Añadir Subsidiaria",
                    selectSubsidiary: "Seleccione una subsidiaria",
                    noSubsidiaries: "No hay subsidiarias registradas",
                    actions: "Acciones",
                    infoText: "Lista de subsidiarias asociadas a esta compañía.",
                    vigencia: "Vigencia",
                    selectVigencia: "Seleccione una vigencia",
                    selectVigenciaMsg: "Seleccione una vigencia para ver las subsidiarias.",
                    newVigencia: "Nueva vigencia",
                    createVigencia: "Crear vigencia",
                    propagationInfo: "Al crear la vigencia se propagarán automáticamente las subsidiarias de la vigencia anterior."
                }
            } else {
                return {
                    listSubsidiary: "List of Subsidiaries",
                    subsidiary: "Subsidiary",
                    stake: "Stake",
                    matrix: "Matrix:",
                    create: "Create",
                    save: "Save",
                    close: "Close",
                    addSubsidiary: "Add Subsidiary",
                    selectSubsidiary: "Select a subsidiary",
                    noSubsidiaries: "No subsidiaries registered",
                    actions: "Actions",
                    infoText: "List of subsidiaries associated with this company.",
                    vigencia: "Validity",
                    selectVigencia: "Select a validity",
                    selectVigenciaMsg: "Select a validity to view subsidiaries.",
                    newVigencia: "New validity",
                    createVigencia: "Create validity",
                    propagationInfo: "When creating the validity, the subsidiaries from the previous validity will be automatically propagated."
                }
            }
        }
    },
    methods: {
        clicked() {
            this.selSubsidiary = ""
            this.cantPartici = ""
            this.showRow = false
            this.selVigencia = ""
            this.newVigencia = ""
            this.editingId = null
            this.editingParticipacion = null
            this.$emit('clicked', false)
        },
        getNameSubsidiary(id) {
            let objSubsidiary = this.listCompanySub.find((obj) => obj.id === id)
            return objSubsidiary ? `${objSubsidiary?.codigo} ${objSubsidiary?.nombre}` : 'N/A'
        },
        loadVigencias() {
            Subsidiary.getVigencias()
                .then((res) => {
                    this.listVigencias = res.data.vigencias || []
                })
                .catch((error) => {
                    console.log(error)
                    this.listVigencias = []
                })
        },
        onVigenciaChange(val) {
            this.editingId = null
            this.editingParticipacion = null
            if (val === "__NEW__") {
                this.subsidiaryList = []
                return
            }
            this.newVigencia = ""
            this.loadSubsidiaries(val)
        },
        async createVigencia() {
            const val = (this.newVigencia || "").trim()

            if (!/^\d{6}$/.test(val)) {
                this.$toast.error("La vigencia debe tener el formato YYYYMM (6 dígitos). Ej: 202501")
                return
            }

            if (this.listVigencias.includes(val)) {
                this.$toast.warning("Esa vigencia ya existe.")
                this.selVigencia = val
                this.loadSubsidiaries(val)
                return
            }

            if (!this.companyName?.id) {
                this.$toast.error("No se pudo identificar la compañía.")
                return
            }

            // Registrar la nueva vigencia en la lista local
            this.listVigencias.push(val)
            this.listVigencias.sort((a, b) => b.localeCompare(a))
            this.selVigencia = val
            this.newVigencia = ""
            this.subsidiaryList = []

            // Propagación automática desde la vigencia anterior
            try {
                const res = await Subsidiary.copyFromPreviousVigencia({
                    idMatriz: this.companyName.id,
                    newVigencia: val,
                    idUser: this.$store.state.userId
                })

                const copied = res.data.copied || 0

                if (copied > 0) {
                    this.$toast.success(
                        `Vigencia creada. Se propagaron ${copied} subsidiarias desde ${res.data.fromVigencia}.`
                    )
                } else {
                    this.$toast.info(
                        res.data.message || "Vigencia creada. No había subsidiarias para propagar."
                    )
                }

                this.loadSubsidiaries(val)
            } catch (error) {
                console.log(error)
                this.$toast.warning(
                    error.response?.data?.message ||
                    "Vigencia creada, pero no se pudieron propagar las subsidiarias anteriores."
                )
                this.loadSubsidiaries(val)
            }
        },
        loadSubsidiaries(vigenciaParam) {
            const vig = vigenciaParam || this.selVigencia
            if (!vig || vig === "__NEW__" || !this.companyName?.id) return

            Subsidiary.getAllSubsidiaryByComp(this.companyName.id, vig)
                .then((res) => {
                    this.subsidiaryList = res.data.subsidiary || []
                })
                .catch((error) => {
                    console.log(error)
                    this.subsidiaryList = []
                })
        },
        newSubsidiary() {
            this.showRow = true

            this.listCompany = [...this.listCompanySub]

            if (this.subsidiaryList.length != 0) {
                this.subsidiaryList.forEach(element => {
                    this.listCompany = this.listCompany.filter((compId) =>
                        compId.id != element.id_subsidiaria && compId.id != this.companyName.id
                    )
                })
            } else {
                this.listCompany = this.listCompany.filter((compId) => compId.id != this.companyName.id)
            }

            return this.listCompany
        },
        createSubsidiary() {
            if (this.selSubsidiary == "") {
                this.$toast.error("El campo Subsidiaria debe ser diligenciado")
                return
            }
            if (this.cantPartici == "") {
                this.$toast.error("El campo Participación debe ser diligenciado")
                return
            }
            if (this.cantPartici < 0 || this.cantPartici > 100) {
                this.$toast.error("El campo Participación debe estar entre 0 y 100")
                return
            }

            let form = {
                'idMatriz': this.companyName.id,
                'idSubsidiaria': this.selSubsidiary,
                'participacion': this.cantPartici,
                'idUser': this.$store.state.userId,
                'vigencia': this.selVigencia
            }

            Subsidiary.createMatrizSubsi(form)
                .then((res) => {
                    this.$toast.success(res.data.message)
                    this.loadSubsidiaries(this.selVigencia)
                    this.showRow = false
                    this.selSubsidiary = ""
                    this.cantPartici = ""
                })
                .catch((error) => {
                    this.$toast.error(error.response?.data?.message || "La matriz no puede tener esta compañía como subsidiaria, ya que esta es su matriz principal")
                    this.error = true
                })
        },
        startEdit(subsidiary) {
            this.editingId = subsidiary.id
            this.editingParticipacion = subsidiary.participacion
        },
        cancelEdit() {
            this.editingId = null
            this.editingParticipacion = null
        },
        saveEdit(subsidiary) {
            const val = parseFloat(this.editingParticipacion)

            if (isNaN(val)) {
                this.$toast.error("El campo Participación debe ser un número válido")
                return
            }
            if (val < 0 || val > 100) {
                this.$toast.error("El campo Participación debe estar entre 0 y 100")
                return
            }

            const form = {
                participacion: val,
                idUser: this.$store.state.userId,
                vigencia: this.selVigencia
            }

            Subsidiary.updateMatrizSubsi(subsidiary.id, form)
                .then((res) => {
                    this.$toast.success(res.data.message || "Subsidiaria actualizada correctamente.")
                    this.editingId = null
                    this.editingParticipacion = null
                    this.loadSubsidiaries(this.selVigencia)
                })
                .catch((error) => {
                    this.$toast.error(error.response?.data?.message || "No fue posible actualizar la subsidiaria.")
                })
        },
        confirmDeleteSubsidiary(subsidiary) {
            this.subsidiaryToDelete = subsidiary
            this.showDeleteModal = true
        },
        closeDeleteModal() {
            this.showDeleteModal = false
            this.subsidiaryToDelete = null
        },
        confirmDelete() {
            if (!this.subsidiaryToDelete) return
            this.deleteSubsidiary(this.subsidiaryToDelete)
        },
        deleteSubsidiary(subsidiary) {
            if (!subsidiary) return

            const companyId = this.companyName?.id
            const subsidiaryId = subsidiary?.id_subsidiaria

            if (!companyId || !subsidiaryId) return

            Subsidiary.deleteMatrizSubsi(companyId, subsidiaryId, this.selVigencia)
                .then((res) => {
                    this.$toast.success(res.data.message || "Subsidiaria eliminada correctamente.")
                    this.showDeleteModal = false
                    this.subsidiaryToDelete = null
                    if (this.editingId === subsidiary.id) {
                        this.editingId = null
                        this.editingParticipacion = null
                    }
                    this.loadSubsidiaries(this.selVigencia)
                })
                .catch((error) => {
                    this.$toast.error(error.response?.data?.message || "No fue posible eliminar la subsidiaria.")
                })
        }
    },
    mounted() {
        Company.getAllCompanies()
            .then((result) => {
                this.listCompany = result.data.companies
                this.listCompanySub = result.data.companies
            })
            .catch((error) => {
                console.log(error)
            })

        this.loadVigencias()
    },
    watch: {
        showDialogInfo(val) {
            if (val) {
                this.listCompany = [...this.listCompanySub]
                this.showRow = false
                this.selSubsidiary = ""
                this.cantPartici = ""
                this.selVigencia = ""
                this.newVigencia = ""
                this.subsidiaryList = []
                this.editingId = null
                this.editingParticipacion = null
                this.loadVigencias()
            }
        }
    }
}
</script>

<style src="../main.css"></style>